import React from "react";
import { Navbar } from "../components/Navbar";
import { Footer2 } from "../components/Footer2";
import { Button } from "../components/ui/Button";
import { Link } from "react-router-dom";
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  CardFooter,
} from "../components/ui/Card";
import { Check } from "lucide-react";
import { Badge } from "antd";
import { Clock, FileText, Calendar, DollarSign, Users } from "lucide-react";

export default function DevenirClient() {
  const serviceOffers = [
    {
      title: "Gestion",
      description:
        "Vous nous mandatez pour recruter et gérer l'administratif de",
      emphasis: "votre recrue",
      ctaText: "Demander un devis",
      features: [
        "Contrat de travail + DPAE",
        "Fiche de paie",
        "Déclarations sociales",
      ],
      billingInfo: "Vous recevrez une facture par mois",
      isPopular: false,
    },
    {
      title: "Délégation",
      description:
        "Vous nous mandatez pour recruter et gérer l'administratif de",
      emphasis: "notre recrue",
      ctaText: "Demander un devis",
      features: [
        "Recrutement du profil recherché",
        "Contrat de travail + DPAE",
        "Fiche de paie",
        "Déclarations sociales",
      ],
      billingInfo: "Vous recevrez une facture par mois",
      isPopular: true,
    },
    {
      title: "Placement",
      description: "Vous nous mandatez pour le recrutement d'un poste en",
      emphasis: "CDD ou CDI ou Vacation",
      ctaText: "Demander un devis",
      features: ["Recrutement du profil recherché", "Conseils RH"],
      billingInfo: "Vous recevrez une seule facture",
      isPopular: false,
    },
  ];

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-grow">
        {/* Hero Section */}
        <section className="bg-gradient-to-r from-blue-50 to-indigo-50 pt-[154px] pb-16">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto text-center mb-10">
              <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                Nos solutions pour les entreprises
              </h1>
              <p className="text-lg text-gray-700 text-justify">
                Chez J'm intérim, chaque jour, nous nous efforçons d'offrir un
                service d'excellence et de faciliter la vie de nos clients en
                gérant leurs besoins en ressources humaines.
                <br></br>
                <br></br>
                Nous plaçons l’humain au cœur de notre métier et allions
                simplicité, fiabilité et réactivité à des prix très attractifs.
              </p>
            </div>
          </div>
        </section>

        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto text-center mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">
                Pourquoi passer par nous ?
              </h2>
              <p className="text-lg text-gray-600">
                Nos valeurs et notre expertise font de J'M Intérim votre
                partenaire idéal pour tous vos besoins en recrutement.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
              {/* Card 1 */}
              <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100 flex flex-col items-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 mb-4">
                  <Clock className="h-8 w-8" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">
                  Gain de temps
                </h3>
                <br></br>
                <p className="text-gray-600 text-justify">
                  Nous vous aidons à répondre très rapidement à un besoin
                  ponctuel ou permanent de personnel lié à une augmentation
                  d'activité, aux congés, à l'absence de salariés ou à une
                  mission nécessitant des compétences non pourvues en interne.
                </p>
              </div>

              {/* Card 2 */}
              <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100 flex flex-col items-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 mb-4">
                  <FileText className="h-8 w-8" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">
                  Réduction des formalités
                </h3>
                <br></br>
                <p className="text-gray-600 text-justify">
                  Vous n'avez plus à rédiger des contrats, à réaliser des fiches
                  de paie ou à faire des déclarations sociales qui peuvent être
                  chronophage.
                </p>
              </div>

              {/* Card 3 */}
              <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100 flex flex-col items-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 mb-4">
                  <Calendar className="h-8 w-8" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">
                  Aménagement du terme du contrat
                </h3>
                <p className="text-gray-600 text-justify">
                  Le contrat d'intérim est plus souple que le contrat de travail
                  en CDD. Vous pouvez, par exemple, avancer le terme de la
                  mission de travail temporaire ou, au contraire, en reporter
                  l'issue, grâce à la souplesse.
                </p>
              </div>

              {/* Card 4 */}
              <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100 flex flex-col items-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 mb-4">
                  <DollarSign className="h-8 w-8" />
                </div>

                <h3 className="text-xl font-semibold text-gray-900 mb-3">
                  Avance de trésorerie
                </h3>
                <br></br>
                <p className="text-gray-600 text-justify">
                  Le délais entre la date à laquelle l'intérimaire sera payé et
                  la date d'écheance de votre facture, vous permet de bénéficier
                  d'une avance de trésorerie.
                </p>
              </div>

              {/* Card 5 */}
              <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100 flex flex-col items-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 mb-4">
                  <Users className="h-8 w-8" />
                </div>

                <h3 className="text-xl font-semibold text-gray-900 mb-3">
                  Masse salariale
                </h3>
                <br></br>
                <p className="text-gray-600 text-justify">
                  L'intérimaire venu en remplacement, ne compte pas parmi votre
                  effectif, il n'est donc pas comptabilisé dans votre masse
                  salariale. Cette dernière est utilisée comme base d'imposition
                  à diverses taxes (ex : taxe d'apprentissage).
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-16 bg-gray-50">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto text-center mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">
                Nos secteurs d'expertise
              </h2>
              <p className="text-lg text-gray-600 text-justify">
                Nous intervenons dans de nombreux domaines d'activité avec une
                connaissance approfondie des spécificités de chaque secteur.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
              <div className="bg-white p-6 rounded-lg shadow-sm text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 mx-auto mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-pickaxe-icon lucide-pickaxe"
                  >
                    <path d="M14.531 12.469 6.619 20.38a1 1 0 1 1-3-3l7.912-7.912" />
                    <path d="M15.686 4.314A12.5 12.5 0 0 0 5.461 2.958 1 1 0 0 0 5.58 4.71a22 22 0 0 1 6.318 3.393" />
                    <path d="M17.7 3.7a1 1 0 0 0-1.4 0l-4.6 4.6a1 1 0 0 0 0 1.4l2.6 2.6a1 1 0 0 0 1.4 0l4.6-4.6a1 1 0 0 0 0-1.4z" />
                    <path d="M19.686 8.314a12.501 12.501 0 0 1 1.356 10.225 1 1 0 0 1-1.751-.119 22 22 0 0 0-3.393-6.319" />
                  </svg>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  BTP
                </h3>
                <p className="text-sm text-gray-600">
                  Maçons, peintres, électriciens, plombiers, manoeuvres...
                </p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-sm text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 mx-auto mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-heart-pulse-icon lucide-heart-pulse"
                  >
                    <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
                    <path d="M3.22 12H9.5l.5-1 2 4.5 2-7 1.5 3.5h5.27" />
                  </svg>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  Santé
                </h3>
                <p className="text-sm text-gray-600">
                  Infirmiers, aides-soignants, FFAS, ASH...
                </p>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-sm text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 mx-auto mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-factory-icon lucide-factory"
                  >
                    <path d="M2 20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8l-7 5V8l-7 5V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z" />
                    <path d="M17 18h1" />
                    <path d="M12 18h1" />
                    <path d="M7 18h1" />
                  </svg>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  Industrie
                </h3>
                <p className="text-sm text-gray-600">
                  Opérateurs, caristes, techniciens de maintenance...
                </p>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-sm text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 mx-auto mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-8 w-8"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z" />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0"
                    />
                  </svg>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  Logistique
                </h3>
                <p className="text-sm text-gray-600">
                  Préparateurs de commandes, chauffeurs VL PL SPL,
                  magasiniers...
                </p>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-sm text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 mx-auto mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-8 w-8"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                    />
                  </svg>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  Tertiaire
                </h3>
                <p className="text-sm text-gray-600">
                  Assistants administratifs, comptables, commerciaux...
                </p>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-sm text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 mx-auto mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-8 w-8"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                    />
                  </svg>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  Services
                </h3>
                <p className="text-sm text-gray-600">
                  Cuisiniers, femmes/valets de chambre,serveurs ...
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-16 bg-white">
          <div className="container mx-auto px-40">
            <div className="max-w-3xl mx-auto text-center mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">
                Nos offres de services
              </h2>
              <p className="text-lg text-gray-600 text-justify">
                Choisissez la solution qui correspond le mieux à vos besoins et
                bénéficiez de l'expertise J'M Intérim.
              </p>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-stretch">
              {serviceOffers.map((offer, index) => (
                <Card
                  key={index}
                  className={`flex flex-col rounded-xl shadow-lg transition-all duration-300 hover:shadow-2xl ${offer.isPopular ? "bg-gradient-to-br from-purple-600 to-pink-500 text-white scale-105" : "bg-white"}`}
                >
                  {offer.isPopular && (
                    <Badge className="absolute -top-3 left-1/2 -translate-x-1/2 bg-white text-purple-700 font-semibold px-4 py-1 rounded-full border border-purple-300 shadow-md text-lg">
                      Le plus populaire
                    </Badge>
                  )}
                  <CardHeader className="pt-10 pb-6 text-center">
                    <CardTitle
                      className={`text-4xl font-extrabold mb-2 ${offer.isPopular ? "text-white" : "text-gray-900"}`}
                    >
                      {offer.title}
                    </CardTitle>
                    <p
                      className={`text-sm ${offer.isPopular ? "text-purple-100" : "text-gray-500"}`}
                    >
                      {offer.description}{" "}
                      <strong
                        className={
                          offer.isPopular ? "text-white" : "text-gray-700"
                        }
                      >
                        {offer.emphasis}
                      </strong>
                      .
                    </p>
                  </CardHeader>
                  <CardContent className="flex-grow flex flex-col justify-between px-6 pb-6">
                    <div>
                      <Link state={{ title: offer.title }} to="/contact">
                        <Button
                          className={`w-full text-lg font-semibold py-3 rounded-lg shadow-md transition-all duration-300 
                                        ${
                                          offer.isPopular
                                            ? "bg-white text-purple-600 hover:bg-purple-50"
                                            : "bg-gradient-to-r from-blue-600 to-cyan-500 hover:from-blue-700 hover:to-cyan-600 text-white"
                                        }
                                        hover:scale-105`}
                        >
                          {offer.ctaText}
                        </Button>
                      </Link>

                      <p
                        className={`text-sm font-semibold mt-6 mb-3 ${offer.isPopular ? "text-purple-50" : "text-gray-700"}`}
                      >
                        Inclus dans cette offre :
                      </p>
                      <ul className="space-y-2 mb-6">
                        {offer.features.map((feature, i) => (
                          <li key={i} className="flex items-center">
                            <Check
                              className={`h-5 w-5 mr-3 flex-shrink-0 ${offer.isPopular ? "text-purple-200" : "text-blue-500"}`}
                            />
                            <span
                              className={`text-sm ${offer.isPopular ? "text-purple-50" : "text-gray-600"}`}
                            >
                              {feature}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div className="mt-auto">
                      <Badge
                        variant={offer.isPopular ? "outline" : "secondary"}
                        className={
                          `w-full flex items-center justify-center py-2 text-sm font-medium rounded-full 
                                        ${
                                          offer.isPopular
                                            ? "bg-transparent border-purple-300 text-white hover:bg-white/30"
                                            : "bg-gray-100 text-gray-700 border-gray-200"
                                        }
                                        whitespace-nowrap` // Added whitespace-nowrap
                        }
                      >
                        {offer.billingInfo}
                      </Badge>
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </section>

        {/* Process */}
        <section className="py-16 bg-gray-50">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto text-center mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">
                Notre processus de collaboration
              </h2>
              <p className="text-lg text-gray-600">
                Une méthode simple et efficace pour répondre rapidement à vos
                besoins
              </p>
            </div>

            <div className="relative">
              {/* Vertical line */}
              <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-blue-100"></div>

              <div className="space-y-6">
                <div className="relative flex flex-col md:flex-row items-center">
                  <div className="md:w-2/4 md:pr-12 md:text-right mb-6 md:mb-0 ">
                    <h3 className="text-xl font-semibold text-gray-900 mb-200">
                      Analyse de vos besoins
                    </h3>
                    <p className="text-gray-600">
                      Nous échangeons en détail sur vos besoins en personnel, la
                      nature des postes, les compétences requises et votre
                      culture d'entreprise.
                    </p>
                  </div>
                  <div className="absolute top-0 md:left-1/2 md:transform md:-translate-x-1/2 flex items-center justify-center w-12 h-12 rounded-full bg-blue-600 text-white font-bold z-10">
                    1
                  </div>
                  <div className="md:w-1/5 md:pl-12">
                    <div className="md:hidden">
                      <h3 className="text-xl font-semibold text-gray-900 mb-2">
                        Analyse de vos besoins
                      </h3>
                      <p className="text-gray-600 line-clamp-3">
                        Nous échangeons en détail sur vos besoins en personnel,
                        la nature des postes, les compétences requises et votre
                        culture d'entreprise.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="relative flex flex-col md:flex-row items-center">
                  <div className="md:w-1/3 md:pl-12 md:text-left mb-6 md:mb-0 md:order-1">
                    <div className="hidden md:block">
                      <h3 className="text-xl font-semibold text-gray-900 mb-2 ">
                        Sélection des candidats
                      </h3>
                      <p className="text-gray-600">
                        Nous recherchons dans notre base de talents et sur le
                        marché les profils correspondant précisément à vos
                        attentes et réalisons une pré-sélection rigoureuse.
                      </p>
                    </div>
                  </div>
                  <div className="absolute top-0 md:left-1/2 md:transform md:-translate-x-1/2 flex items-center justify-center w-12 h-12 rounded-full bg-blue-600 text-white font-bold z-10">
                    2
                  </div>
                  <div className="md:w-1/2 md:pl-12 md:order-0">
                    <div className="md:hidden">
                      <h3 className="text-xl font-semibold text-gray-900 mb-2">
                        Sélection des candidats
                      </h3>
                      <p className="text-gray-600">
                        Nous recherchons dans notre base de talents et sur le
                        marché les profils correspondant précisément à vos
                        attentes et réalisons une pré-sélection rigoureuse.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="relative flex flex-col md:flex-row items-center">
                  <div className="md:w-1/2 md:pr-12 md:text-right mb-6 md:mb-0">
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">
                      Présentation des profils
                    </h3>
                    <p className="text-gray-600">
                      Nous vous présentons uniquement les candidats ayant
                      répondu favorablement à nos critères de sélection et
                      correspondant à vos attentes.
                    </p>
                  </div>
                  <div className="absolute top-0 md:left-1/2 md:transform md:-translate-x-1/2 flex items-center justify-center w-12 h-12 rounded-full bg-blue-600 text-white font-bold z-10">
                    3
                  </div>
                  <div className="md:w-1/2 md:pl-12">
                    <div className="md:hidden">
                      <h3 className="text-xl font-semibold text-gray-900 mb-2">
                        Présentation des profils
                      </h3>
                      <p className="text-gray-600">
                        Nous vous présentons uniquement les candidats ayant
                        répondu favorablement à nos critères de sélection et
                        correspondant à vos attentes.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="relative flex flex-col md:flex-row items-center">
                  <div className="md:w-1/3 md:pl-12 md:text-left mb-6 md:mb-0 md:order-1">
                    <div className="hidden md:block">
                      <h3 className="text-xl font-semibold text-gray-900 mb-2">
                        Gestion administrative
                      </h3>
                      <p className="text-gray-600 ">
                        Nous nous occupons de toutes les formalités
                        administratives : contrats, déclarations, fiches de
                        paie, facturation, permettant de vous concentrer sur
                        votre cœur de métier.
                      </p>
                    </div>
                  </div>
                  <div className="absolute top-0 md:left-1/2 md:transform md:-translate-x-1/2 flex items-center justify-center w-12 h-12 rounded-full bg-blue-600 text-white font-bold z-10">
                    4
                  </div>
                  <div className="md:w-1/2 md:pl-12 md:order-0">
                    <div className="md:hidden">
                      <h3 className="text-xl font-semibold text-gray-900 mb-2">
                        Gestion administrative
                      </h3>
                      <p className="text-gray-600">
                        Nous nous occupons de toutes les formalités
                        administratives : contrats, déclarations, fiches de
                        paie, facturation, permettant de vous concentrer sur
                        votre cœur de métier.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="relative flex flex-col md:flex-row items-center">
                  <div className="md:w-1/2 md:pr-12 md:text-right mb-6 md:mb-0">
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">
                      Suivi de mission
                    </h3>
                    <p className="text-gray-600">
                      Nous assurons un suivi régulier auprès de vous et des
                      intérimaires pour garantir le bon déroulement des missions
                      et la satisfaction de toutes les parties.
                    </p>
                  </div>
                  <div className="absolute top-0 md:left-1/2 md:transform md:-translate-x-1/2 flex items-center justify-center w-12 h-12 rounded-full bg-blue-600 text-white font-bold z-10">
                    5
                  </div>
                  <div className="md:w-1/2 md:pl-12">
                    <div className="md:hidden">
                      <h3 className="text-xl font-semibold text-gray-900 mb-2">
                        Suivi de mission
                      </h3>
                      <p className="text-gray-600">
                        Nous assurons un suivi régulier auprès de vous et des
                        intérimaires pour garantir le bon déroulement des
                        missions et la satisfaction de toutes les parties.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Call To Action */}
        <section className="py-16 bg-blue-600">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-3xl font-bold text-white mb-6">
              Prêt à collaborer avec J'M Intérim ?
            </h2>
            <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
              Découvrez comment nous pouvons répondre à vos besoins en
              recrutement
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <Link to="/contact">
                <Button
                  variant="outline"
                  className="border-white text-blue-600 bg-white hover:bg-blue-100 text-lg px-6 py-3"
                >
                  Nous contacter
                </Button>
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer2 />
    </div>
  );
}
